import { jsx as _jsx } from "react/jsx-runtime";
import { QueryErrorResetBoundary } from '@tanstack/react-query';
import { createBrowserRouter as routerCreateBrowserRouter, Navigate, } from 'react-router-dom';
import { LoadingBox, translate } from '@lucidlink/uicore';
import { childRouteObjects, wrapCreateBrowserRouterV7, } from '@lucidlink/workspacemanagement';
import { AppError, ErrorBoundary, FatalError, MainError, } from '@lucidlink/workspacemanagement/router/components';
import { webRouteObjects } from '#router/webRouteObject';
import { Main } from './Main';
const createBrowserRouter = wrapCreateBrowserRouterV7(routerCreateBrowserRouter);
export function createRouter(
// eslint-disable-next-line @typescript-eslint/naming-convention -- Providers is element type and must be capitalized
InfraProviders, 
// eslint-disable-next-line @typescript-eslint/naming-convention -- Providers is element type and must be capitalized
AppProviders) {
    return createBrowserRouter([
        {
            path: '/',
            element: (_jsx(InfraProviders, { children: _jsx(QueryErrorResetBoundary, { children: ({ reset: resetQueries }) => (_jsx(ErrorBoundary, { DefaultFallback: AppError, name: "AppErrorBoundary", onReset: resetQueries, children: _jsx(AppProviders, { children: _jsx(ErrorBoundary, { DefaultFallback: MainError, name: "MainErrorBoundary", onReset: resetQueries, children: _jsx(Main, {}) }) }) })) }) })),
            errorElement: _jsx(FatalError, {}),
            hydrateFallbackElement: (_jsx(LoadingBox, { alt: translate('Loading LucidLink'), "data-testid": 'loading-lucidlink', isFullHeight: true })),
            children: [...childRouteObjects, ...webRouteObjects],
        },
        {
            index: true,
            element: _jsx(Navigate, { to: "/home" }),
        },
        {
            path: '*',
            element: _jsx(Navigate, { to: "/home" }),
        },
    ]);
}
